<template>
	<div class="building">
		<div>
			<img class="img" src="../../static/img/building.png" alt="">
			<div class="txt"><span style="font-size: xx-large;">我们正在努力建设中，新版块敬请期待......</span></div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'Building',
		data() {
			return {
			}
		},
		mounted() {

		},
		methods: {
			
		},
	}

</script>

<!-- <style lang="scss" scoped> -->
.building {
	width: 100%;
	// height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 10%;
	.img {
		display: inline-block;
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}
	.txt {
		text-align: center;
		color: #666;
		margin-top: 20px;
		
	}
}
</style>


// WEBPACK FOOTER //
// src/components/building.vue